import { useState, useEffect, useCallback } from "react";
import { useLocation, useHistory } from "react-router-dom";
import $axios from "../services/axios";

export const usePaymentResultLogic = ({ setLoading }) => {
    const location = useLocation();
    const history = useHistory();
    const [statusPayment, setStatusPayment] = useState(true);
    const [bookingHotel, setBookingHotel] = useState(null);

    const handleBooking = useCallback(async () => {
        const queryParams = new URLSearchParams(location.search);
        const amount = queryParams.get("amount");
        const payment_type = queryParams.get("payment_type");
        const reference_number = queryParams.get("reference_number");
        const status = queryParams.get("status");
        const trans_ref_no = queryParams.get("trans_ref_no");
        const website_id = queryParams.get("website_id");
        const signature = queryParams.get("signature");
        const messageVtc = queryParams.get("message");

        setStatusPayment(status === "1");

        try {
            // Uncomment logic for payment handle
            // const body = {
            //     OrderId: reference_number,
            //     Amount: amount,
            //     Message: messageVtc,
            //     Status: Number(status),
            //     PaymentType: payment_type,
            //     ReferenceNumber: reference_number,
            //     TransRefNo: trans_ref_no,
            //     WebsiteId: website_id,
            //     Signature: signature,
            // };
            // await $axios.$post("/payment/paymentHandle", body);
        } catch (error) {
            // console.log(error, "error");
        } finally {
            // Clear URL params without reloading
            // setTimeout(() => {
            //     const { pathname } = location;
            //     history.replace(pathname);
            // }, 5000); 
        }
    }, [location.search, history]);

    useEffect(() => {
        handleBooking();
    }, [handleBooking]);

    return {
        statusPayment,
        setStatusPayment,
        bookingHotel,
        setBookingHotel,
        handleBooking
    };
};
